import { addDays, addMonths } from 'date-fns'

export const actionTypes = {
  ACTION_NEXT: 'next',
  ACTION_SCHEDULE: 'schedule',
  ACTION_WAITING: 'wait',
  ACTION_SOMEDAY: 'someday',
  ACTION_DO: 'done',
  ACTION_REFERENCE: 'reference',
  ACTION_TRASH: 'trash'
}

export const actionVerbs = {
  [actionTypes.ACTION_NEXT]: 'Defer',
  [actionTypes.ACTION_SCHEDULE]: 'Schedule',
  [actionTypes.ACTION_WAITING]: 'Delegate',
  [actionTypes.ACTION_SOMEDAY]: 'Incubate',
  [actionTypes.ACTION_DO]: 'Do',
  [actionTypes.ACTION_REFERENCE]: 'Bookmark',
  [actionTypes.ACTION_TRASH]: 'Trash'
}

export const actionFilters = {
  [actionTypes.ACTION_NEXT] (shit) {
    return shit.action === actionTypes.ACTION_NEXT
  },
  [actionTypes.ACTION_SCHEDULE] (shit) {
    return shit.action === actionTypes.ACTION_SCHEDULE || ('scheduledAt' in shit && shit.scheduledAt)
  },
  [actionTypes.ACTION_WAITING] (shit) {
    return shit.action === actionTypes.ACTION_WAITING || (shit.mentions && shit.mentions.length)
  },
  [actionTypes.ACTION_SOMEDAY] (shit) {
    return shit.action === actionTypes.ACTION_SOMEDAY
  },
  [actionTypes.ACTION_DO] (shit) {
    return shit.completedAt !== null
  },
  [actionTypes.ACTION_REFERENCE] (shit) {
    return shit.action === actionTypes.ACTION_REFERENCE
  },
  [actionTypes.ACTION_TRASH] (shit) {
    return shit.action === actionTypes.ACTION_TRASH
  }
}

// @todo move to own js
const createScheduledNotification = (title, body, schedule, tag) => {
  if (!('showTrigger' in Notification.prototype)) {
    return
  }

  // @todo show modal to inform the user if they want to be notified, then request access
  const promise = Notification.permission === 'default' ? Notification.requestPermission() : Promise.resolve()
  promise.then(() => {
    if (Notification.permission !== 'granted') {
      return
    }

    navigator.serviceWorker.getRegistration().then((registration) => {
      if (!registration) {
        return
      }

      registration.showNotification(title, {
        tag: tag,
        body: body,
        // eslint-disable-next-line
        showTrigger: new TimestampTrigger(schedule)
      })
    })
  })
}

/*
const cancelScheduledNotification = async (tag) => {
  const registration = await navigator.serviceWorker.getRegistration()
  const notifications = await registration.getNotifications({
    tag: tag,
    includeTriggered: true
  })
  notifications.forEach((notification) => notification.close())
}
*/

export const actionTriggers = {
  [actionTypes.ACTION_NEXT] () {
    // do nothing
  },
  [actionTypes.ACTION_SCHEDULE] (shit) {
    createScheduledNotification(shit.description, 'Scheduled Today', shit.scheduledAt.start, shit.uuid)
  },
  [actionTypes.ACTION_WAITING] (shit) {
    const schedule = addDays(new Date(), 7)
    createScheduledNotification(shit.description, 'Waiting', schedule, shit.uuid)
  },
  [actionTypes.ACTION_SOMEDAY] (shit) {
    const schedule = addMonths(new Date(), 1)
    createScheduledNotification(shit.description, 'Incubation', schedule, shit.uuid)
  },
  [actionTypes.ACTION_DO] (shit) {
    shit.completedAt = new Date()
  },
  [actionTypes.ACTION_REFERENCE] () {
    // do nothing
  },
  [actionTypes.ACTION_TRASH] (shit) {
    shit.deletedAt = new Date()
  }
}
